/** 停机停手的展示判定与危险动作可用性。
 *
 * 内核侧是硬约束（`Ledger.assert_trading_allowed` 抛 `HaltedError`），前端这些判据
 * 只决定「按钮能不能点 / 提示怎么写」，**不是安全边界**——真正的拒绝在服务端
 * （停机期间 `POST /runs` 返回 409）。批次 1 才接停机动作，批次 0 只做展示。
 */

import type { StatusPayload } from "../api/types";

export type HaltTone = "halt" | "ok";

export interface HaltView {
  halted: boolean;
  tone: HaltTone;
  /** 横条上的主文案。 */
  label: string;
  /** 停止的原因（内核原样给出时按原样显示）。 */
  reason: string | null;
  /** 下单闸门的现状描述。 */
  gate: string;
  /** 批次 0 尚未接的写入口——界面上必须显示成「未接线」而不是可点的按钮。 */
  recoveryWired: false;
}

export function describeHalt(status: Pick<StatusPayload, "halted" | "halt_reason">): HaltView {
  const halted = status.halted;
  return {
    halted,
    tone: halted ? "halt" : "ok",
    label: halted ? "停机停手" : "可下单",
    reason: status.halt_reason,
    gate: halted ? "已关闭（新订单一律拒）" : "开启",
    recoveryWired: false,
  };
}

/** 顶栏状态灯：先看停机，再看对账，最后才是账本摘要。 */
export type ChipTone = "ok" | "warn" | "bad";

export function statusChips(status: StatusPayload): { tone: ChipTone; text: string }[] {
  return [
    { tone: status.halted ? "bad" : "ok", text: status.halted ? "停手" : "可下单" },
    status.balance.checked_run === null
      ? { tone: "warn", text: "还没对过账" }
      : { tone: status.balance.balanced ? "ok" : "bad", text: status.balance.balanced ? "对账平" : "对账不平" },
  ];
}

/** 只在展示层判定的「能不能下单」提示。真判据在服务端。 */
export function runGateHint(status: Pick<StatusPayload, "halted">): string {
  return status.halted
    ? "停机停手期间连回测也不许自动下单——同一份代码路径的必然结果，不是给回测开后门。"
    : "可提交运行。";
}
